/*
class QuickAddDrawer extends HTMLElement {
    constructor() {
      super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#QuickCartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.closeButton = this.querySelector('.drawer__close');

        this.title = this.querySelector('.quick-add-drawer__title');
        this.price = this.querySelector('.quick-add-drawer__price'); 
        this.image1 = this.querySelector('.primary-image');
        this.image2 = this.querySelector('.secondary-image');
        this.productLink = this.querySelector('.quick-add-drawer__link');
        this.test = this.querySelector('.quick-add-drawer__complementary-products');

        this.closeButton.addEventListener('click', () => this.close());
        //this.form.addEventListener('submit', this.addToCart.bind(this));
    }

    open(product) {
        this.classList.add('active');
        console.log(this.title);
        console.log(this.price);
        console.log(product.title)
        // this.title.textContent = product.title;
        this.price.textContent = product.price;

        this.image1.src = product.image;
        this.image1.alt = product.title;
        if (product.image2) {
            this.image2.src = product.image2;
            this.image2.alt = product.title;
            this.image2.style.display = 'block';
        } else {
            this.image2.style.display = 'none';
        }

        this.productLink.href = product.link;

        const rechargeTarget = this.querySelector('.rc-custom-injection-point');
        rechargeTarget.innerHTML = '';
        document.body.classList.add('overflow-hidden');

        this.getProductDetails(product);
        setTimeout(() => {
            if (window.ReChargeWidget && product.productId) {
            window.ReChargeWidget.createWidget({
                productId: product.productId,
                injectionParent: '.quick-add-drawer .rc-custom-injection-point'
            });
            }
        }, 100);
    } 
    
    getProductDetails(product) {
        const url = `${window.Shopify.routes.root}products/${product.handle}?section=main-product`;

        fetch(url)
        .then(res => res.text())
        .then(html => {
            const productInfo = html.querySelector('product-info');
            this.test.innerHTML = html;
        })
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
        //this.title.textContent = "";
        this.price.textContent = ""; 
    }
}

customElements.define('quick-add-drawer', QuickAddDrawer);

document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quick-add-button]');
    if (!button) return;

    const modal = document.querySelector('quick-add-drawer');

    modal.open({
        title: button.dataset.productTitle,
        price: button.dataset.productPrice,
        image: button.dataset.productImage,
        image2: button.dataset.productImageHover,
        link: button.dataset.productUrl,
        handle: button.dataset.handle,
        variantId: button.dataset.variantId,
        productId: button.dataset.productId
    });
}); 
*/

class QuickAddDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#QuickCartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.inner = this.querySelector(".quick-add-drawer__inner");
    this.closeButton = this.querySelector(".drawer__close");

    this.closeButton.addEventListener("click", () => this.close());
  }

  async open(productUrl) {
    this.clear();

    if(productUrl.indexOf('?') != -1) {
      productUrl = productUrl.split("?")[0];
    }
    
    try {
      const response = await fetch(
        `${productUrl}?section_id=quick-add-drawer-content`,
      );
      const html = await response.text();

      this.inner.innerHTML = html;

      this.classList.add("active");
      document.body.classList.add('overflow-hidden');

      this.bindVariantPills();
      this.bindForm();
      this.initRecharge();
    } catch (error) {
      console.error(error);
    }
  }

  bindVariantPills() {
    const pills = this.querySelectorAll(".quick-add-drawer__variant-pill");
    const input = this.querySelector('[name="id"]');
    

    const price = this.querySelector(".quick-add-drawer__price .price-item");

    pills.forEach((pill) => {
      pill.addEventListener("click", () => {
        input.value = pill.dataset.variantId;
        document.dispatchEvent(
          new CustomEvent("variant:change", {
            bubbles: true,
            detail: {
              variant: {
                id: Number(pill.dataset.variantId),
              },
            },
          }),
        );
        this.querySelector(".quick-add-drawer__price").removeAttribute(
          "data-price-mutation-watcher",
        );
        if (price) {
          price.textContent = pill.dataset.variantPrice;
        }

        pills.forEach((button) => button.classList.remove("active"));
        pill.classList.add("active");
      });
    });
  }

  bindForm() {
    const form = this.querySelector(".quick-add-drawer__form");
    const message = this.querySelector(".quick-add-drawer__message");

    if (!form) return;

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const formData = new FormData(form);

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) throw new Error("Cart error");

        message.textContent = "Added to cart.";
        message.hidden = false;

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          const cartResponse = await fetch(
            "/?sections=cart-drawer,cart-icon-bubble",
          );
          const cartSections = await cartResponse.json();

          cartDrawer.renderContents({
            sections: cartSections,
          });

          cartDrawer.classList.remove("is-empty");
        }

        setTimeout(() => {
          this.close();

          if (cartDrawer && typeof cartDrawer.open === "function") {
            cartDrawer.open();
          }
        }, 250);

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
      } catch (error) {
        message.textContent = "Something went wrong. Please try again.";
        message.hidden = false;
      }
    });
  }

  initRecharge() {
    const content = this.querySelector(".quick-add-drawer__wrapper");
    if (!content) return;

    const productId = content.dataset.productId;
    // const productId = content.dataset.variantId;
    // console.log("variant id " + productId);
    setTimeout(() => {
      if (
        window.ReChargeWidget &&
        typeof window.ReChargeWidget.createWidget === "function"
      ) {
        window.ReChargeWidget.createWidget({
          productId: productId,
          injectionParent: ".quick-add-drawer .rc-custom-injection-point",
        });
      }

      if (window.ReCharge && typeof window.ReCharge.init === "function") {
        window.ReCharge.init();
      }

      if (window.RCWidget && typeof window.RCWidget.init === "function") {
        window.RCWidget.init();
      }
    }, 150);
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  clear() {
    this.inner.innerHTML = "";
  }
}

customElements.define("quick-add-drawer", QuickAddDrawer);

document.addEventListener("click", function (event) {
  const button = event.target.closest("[data-quick-add-button]");
  if (!button) return;

  const modal = document.querySelector("quick-add-drawer");

  modal.open(button.dataset.productUrl);
});
